import React, { useContext } from 'react'
import { Routes, Route } from 'react-router-dom'

import NotFound from '../NotFound'

import { AbilityContext } from '../../components/Ability'
import ShopeePage from './Features/Shopee'
import LazadaPage from './Features/Lazada'
import TikTokPage from './Features/Tiktok'
import LineMyShopPage from './Features/LineMyShop'


const MarketplacePage = () => {
  const ability = useContext(AbilityContext)

  return (
    <Routes>
      <Route
        path="/shopee/*"
        element={
          ability.can('read', 'Users') ? <ShopeePage /> : <NotFound />
        }
      />
      <Route
        path="/lazada/*"
        element={
          ability.can('read', 'Users') ? <LazadaPage /> : <NotFound />
        }
      />
      <Route
        path="/tiktok/*"
        element={
          ability.can('read', 'Users') ? <TikTokPage /> : <NotFound />
        }
      />
      <Route
        path="/line-my-shop/*"
        element={
          ability.can('read', 'Users') ? <LineMyShopPage /> : <NotFound />
        }
      />
    </Routes>
  )
}

export default MarketplacePage
